import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

import IconColor from '~/assets/icones/IconColor.svg';
import IconColorB from '~/assets/icones/IconColorB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={
            linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
          }
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
          cor={thisData?.cor}
        >
          <div className="card-body">
            <div className="card-text">
              <p className="descricao">#{thisData?.codigo}</p>
              <p className="titulo">{thisData?.titulo}</p>
            </div>
          </div>
          <div className="card">
            <div className="card-color">
              <img src={localStorage.getItem("tema") == "E" ? IconColor : IconColorB} alt="Vazio" />
            </div>
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
